import {
	Component,
	EventEmitter,
	HostListener,
	Input,
	OnInit,
	Output
} from '@angular/core';
import { Router } from '@angular/router';
import { FacadeService } from 'src/app/core/services/facade.service';
import { DateUtils } from '../../utils/date-utils';

@Component({
	selector: 'app-day-selector',
	templateUrl: './day-selector.component.html',
	styleUrls: ['./day-selector.component.scss']
})
export class DaySelectorComponent implements OnInit {
	//Les types primitifs sont passer par valeur entre les composants, on utilise donc un conteneur pour passer les données par références

	/**
	 * Année
	 */
	yearNumber: { value: number } = { value: null };

	/**
	 * Mois
	 */
	weekNumber: { value: number } = { value: null };

	@Input() etat;
	/**
	 * Event emit lorsque la période change
	 */
	@Output() dateRangeChange: EventEmitter<any> = new EventEmitter();

	monthsFr = [
		'janv',
		'févr',
		'mars',
		'avr',
		'mai',
		'juin',
		'juill',
		'aout',
		'sept',
		'oct',
		'nov',
		'déc'
	];
	daysFr = [
		'Dimanche',
		'Lundi',
		'Mardi',
		'Mercredi',
		'Jeudi',
		'Vendredi',
		'Samedi'
	];

	/**
	 * Date du jour
	 */
	today: Date = new Date();
	selectedDate: Date;

	constructor(
		private dateUtils: DateUtils,
		private facade: FacadeService,
		private router: Router
	) {}

	ngOnInit(): void {
		if (this.facade.dataStorageService.getParam('selectedDate')) {
			this.selectedDate = new Date(
				this.facade.dataStorageService.getParam('selectedDate')
			);
			this.weekNumber.value = this.dateUtils.getWeekNumber(this.selectedDate);
		} else {
			if (
				this.facade.dataStorageService.getParam('storedCalendarWeeknumber') &&
				this.facade.dataStorageService.getParam('storedCalendarYearnumber')
			) {
				this.weekNumber.value = this.facade.dataStorageService.getParam(
					'storedCalendarWeeknumber'
				);
				this.yearNumber.value = this.facade.dataStorageService.getParam(
					'storedCalendarYearnumber'
				);
				this.selectedDate = new Date(
					this.dateUtils.getDateOfISOWeek(
						this.weekNumber.value,
						this.yearNumber.value
					)
				);
			} else {
				let nextDay = new Date(this.today);
				nextDay.setDate(this.today.getDate() + 7);
				this.selectedDate = nextDay;

				this.weekNumber.value = this.dateUtils.getWeekNumber(this.today) + 1;
			}
		}

		// if(this.facade.dataStorageService.getParam('selectedDate')){
		// 	this.selectedDate = new Date(this.facade.dataStorageService.getParam('selectedDate'))
		// 	this.weekNumber.value = this.dateUtils.getWeekNumber(this.selectedDate)
		// } else {
		// 	this.selectedDate = this.today;
		// 	this.weekNumber.value = this.dateUtils.getWeekNumber(this.today);

		// }
	}

	/**
	 * Calcule des dates pour revenir à la semaine précédente
	 */
	previousDay() {
		this.selectedDate.setDate(this.selectedDate.getDate() - 1);
		this.updateSelectedDateInStorage();
		this.router.navigate(['/routes/' + this.etat]);
		return this.selectedDate;

		// this.cleanDateRangeSession();
	}

	/**
	 * Calcule des dates pour aller à la semaine suivante
	 */
	nextDay() {
		this.selectedDate.setDate(this.selectedDate.getDate() + 1);
		this.updateSelectedDateInStorage();
		this.router.navigate(['/routes/' + this.etat]);
		return this.selectedDate;

		// this.updateYearAndWeekNumbers();
		// this.cleanDateRangeSession();
	}

	/**
	 * Calcule pour revenir à la semaine courante
	 */
	resetDateClick() {
		this.selectedDate = this.today;
		this.updateSelectedDateInStorage();
		// this.cleanDateRangeSession();
	}

	/**
	 * Stocke la date selectionnée dans le localStorage
	 */
	updateSelectedDateInStorage() {
		this.weekNumber.value = this.dateUtils.getWeekNumber(this.selectedDate);
		this.yearNumber.value = this.selectedDate.getFullYear();
		this.facade.dataStorageService.setParam(
			'storedCalendarWeeknumber',
			this.weekNumber.value
		);
		this.facade.dataStorageService.setParam(
			'storedCalendarYearnumber',
			this.yearNumber.value
		);

		this.facade.dataStorageService.setParam('selectedDate', this.selectedDate);
	}

	/**
	 * Listener pour les frappes claviers
	 * @param event
	 */
	@HostListener('window:keyup', ['$event'])
	keyEvent(event: KeyboardEvent) {
		if (event.key === 'ArrowLeft') {
			this.previousDay();
		}
		if (event.key === 'ArrowRight') {
			this.nextDay();
		}
	}
}
